import { ProfileLayout } from '@/components/layout/ProfileLayout'
import { ActivityPage } from './ActivityPage'
import '@/styles/dashboard.css'

/** Своя активность в разделе профиля (/profile/activity) */
export function ProfileActivityPage() {
  return (
    <ProfileLayout>
      <ActivityPage />
    </ProfileLayout>
  )
}
